import { useEffect, useState } from "react";

/** Keeps event lifecycle decisions current while a calendar or detail page stays open. */
export function useEventClock(refreshMilliseconds = 30_000): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const timer = window.setInterval(() => setNow(new Date()), refreshMilliseconds);
    return () => window.clearInterval(timer);
  }, [refreshMilliseconds]);

  return now;
}